import { QuestionTitle } from '@/components/decision-tree/components/SurveyItem/components/Question/components/QuestionTitle';
import { Box, InlineAlert, Input } from '@cmpsr/components';
import { FC } from 'react';
import useFreetextController from './Freetext.controller';
import { FreetextProps } from './types';

export const FreetextComp: FC<FreetextProps> = ({ data, saveAnswer, defaultValue, whyWeAskModalDisclosure }) => {
  const { label, id, placeholder, whyWeAskExplanation, tooltip, description, validationValues } = data;
  const { onInputFn, form, validationOptions, onBlurFn } = useFreetextController({
    validationValues,
    saveAnswer,
    defaultValue,
  });

  return (
    <Box width="full" maxWidth="450px">
      <QuestionTitle
        description={description}
        tooltip={tooltip}
        question={label}
        whyWeAskExplanation={whyWeAskExplanation}
        whyWeAskModalDisclosure={whyWeAskModalDisclosure}
      />
      <Box mt={6}>
        <Input
          key={id}
          variant="outline"
          placeholder={placeholder}
          borderColor={
            form.formState.errors.freetext?.message ? 'alert-error-default !important' : 'ui-element-outline-default'
          }
          {...form.register('freetext', validationOptions)}
          onInput={onInputFn}
          onBlur={onBlurFn}
        />
        {form.formState.errors.freetext?.message ? (
          <InlineAlert status="error" mt="spacer-6" alignItems="flex-start">
            <InlineAlert.Icon />
            <InlineAlert.Message>{form.formState.errors.freetext?.message}</InlineAlert.Message>
          </InlineAlert>
        ) : null}
      </Box>
    </Box>
  );
};
